const AdministrationEvent = {
  RELOAD_PAGE: 'AdministrationReloadPage',
  POWER_FLOW_CONFIG_SAVED: 'AdministrationPowerFlowConfigSaved',
  APPLY_DISCARD_CHANGES_HANDLER: 'AdministrationDiscardChanges',
  RESET_DISCARD_CHANGES_HANDLER: 'AdministrationResetDiscardChanges',
  OPEN_CHANGE_DISCARD_MODAL: 'AdministrationOpenChangeDiscardModal',
};

export default AdministrationEvent;
